import { TAppState } from '../../types/appState';

export function chatbotFiltersModalSelector(state: TAppState) {
  return state.chatbotFiltersModal;
}
